import { render, staticRenderFns } from "./MappingManager.vue?vue&type=template&id=ca28c154&lang=pug"
import script from "./MappingManager.vue?vue&type=script&lang=ts"
export * from "./MappingManager.vue?vue&type=script&lang=ts"
import style0 from "./MappingManager.vue?vue&type=style&index=0&id=ca28c154&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports